<div class="monitoring-user-picklist__grid">
  <div class="monitoring-user-picklist__search">
    <div class="monitoring-user-picklist__title-row">
      <h3 class="monitoring-user-picklist__title">{{ addPanelTitle() }}</h3>
      <div class="monitoring-user-picklist__toolbar-actions">
        <button
          type="button"
          class="monitoring-user-picklist__toolbar-btn"
          [disabled]="isLoadingUsers"
          [title]="'Atualizar lista de usuários'"
          (click)="forceRefresh()">
          <i class="pi pi-refresh" [class.pi-spin]="isLoadingUsers"></i>
        </button>
        <button
          type="button"
          class="monitoring-user-picklist__toolbar-btn"
          [title]="companyId() ? 'Cadastrar usuário para esta empresa' : 'Cadastrar novo usuário'"
          (click)="openUserRegisterInNewTab()">
          <i class="pi pi-plus"></i>
        </button>
      </div>
    </div>
    <app-input
      [placeholder]="'Buscar por nome ou e-mail'"
      [(ngModel)]="userSearch"
      [name]="'userSearch'"
      [autocomplete]="'new-password'" />

    <div class="monitoring-user-picklist__user-list">
      @if (isLoadingUsers) {
        <div class="monitoring-user-picklist__loading">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Carregando usuários...</span>
        </div>
      }

      @for (user of filteredUsers; track user.id) {
        <div
          class="monitoring-user-picklist__user-item"
          [class.monitoring-user-picklist__user-item--added]="isMemberAdded(user.id)"
          (click)="!isMemberAdded(user.id) && addMember(user)">
          <div class="monitoring-user-picklist__user-avatar">
            {{ user.firstName?.charAt(0) }}{{ user.surName?.charAt(0) }}
          </div>
          <div class="monitoring-user-picklist__user-info">
            <span class="monitoring-user-picklist__user-name">
              {{ user.firstName }} {{ user.surName }}
            </span>
            <span class="monitoring-user-picklist__user-email">{{ user.email }}</span>
          </div>
          <div
            class="monitoring-user-picklist__add-btn"
            [class.monitoring-user-picklist__add-btn--added]="isMemberAdded(user.id)">
            @if (isMemberAdded(user.id)) {
              <i class="pi pi-check"></i>
            } @else {
              <i class="pi pi-plus"></i>
            }
          </div>
        </div>
      }

      @if (!isLoadingUsers && filteredUsers.length === 0) {
        <div class="monitoring-user-picklist__empty">
          <i class="pi pi-search"></i>
          <span>{{
            userSearch.trim() ? 'Nenhum usuário encontrado' : 'Nenhum usuário disponível'
          }}</span>
        </div>
      }
    </div>
  </div>

  <div class="monitoring-user-picklist__selected">
    <h3 class="monitoring-user-picklist__title">
      {{ selectedPanelTitle() }}
      <span class="monitoring-user-picklist__badge">{{ members().length }}</span>
    </h3>

    @if (members().length === 0) {
      <div class="monitoring-user-picklist__empty">
        <i class="pi pi-user-plus"></i>
        <span
          >Adicione ao menos {{ minMembers() }}
          {{ showCommitteeMemberFields() ? 'membros' : 'assinante(s)' }} para continuar</span
        >
      </div>
    }
    @if (showCommitteeMemberFields() && members().length === 1 && minMembers() > 1) {
      <div class="monitoring-user-picklist__empty">
        <i class="pi pi-info-circle"></i>
        <span>Adicione mais 1 membro para habilitar o próximo passo</span>
      </div>
    }

    <div class="monitoring-user-picklist__members-list">
      @for (member of members(); track member.userId) {
        <div class="monitoring-user-picklist__member-card">
          <div class="monitoring-user-picklist__member-header">
            <div class="monitoring-user-picklist__user-avatar">
              {{ member.displayName?.charAt(0) }}
            </div>
            <div class="monitoring-user-picklist__user-info">
              <span class="monitoring-user-picklist__user-name">{{ member.displayName }}</span>
              <span class="monitoring-user-picklist__user-email">{{ member.email }}</span>
            </div>
            <button
              type="button"
              class="monitoring-user-picklist__remove-btn"
              (click)="removeMember(member.userId)">
              <i class="pi pi-trash"></i>
            </button>
          </div>

          @if (showCommitteeMemberFields()) {
            <div class="monitoring-user-picklist__member-controls">
              <label class="monitoring-user-picklist__field-label">Cargo / Função</label>
              <input
                type="text"
                class="monitoring-user-picklist__role-input"
                placeholder="Ex: Head de Risco"
                [value]="member.roleLabel"
                (input)="updateRoleLabel(member, $any($event.target).value)" />

              <div class="monitoring-user-picklist__vote-toggle">
                <span>Poder de voto</span>
                <button
                  type="button"
                  class="monitoring-user-picklist__toggle-btn"
                  [class.monitoring-user-picklist__toggle-btn--on]="member.hasVotingPower"
                  (click)="toggleVotingPower(member)">
                  {{ member.hasVotingPower ? 'Sim' : 'Não' }}
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
